import { number, string, object } from '@calendly/form/validation'
import { I18n } from '@calendly/i18n'

export const getValidationSchema = () => object({
  provider: string(),
  lastValidProvider: string().nullable(),
  currency: string().nullable(),
  amount: number().nullable().when('provider', {
    is: (provider) => provider !== 'none',
    then: number()
      .typeError(I18n.t('errors.messages.not_a_number'))
      .required(I18n.t('errors.messages.blank'))
      .min(0.5, I18n.t('errors.messages.cannot_be_less_than', { count: '0.50' }))
      .max(99999.99, I18n.t('errors.messages.less_than', { count: 100000 }))
  }),
  paymentTerms: string().max(1024, I18n.t('errors.messages.too_long', { count: 1024 })),
})
